import { jsonMember, jsonObject, jsonArrayMember } from 'typedjson';
import { SequenceSearchResultHitSegmentPairResponse } from '@api/sequence/responses/sequence-search-result-hit-segment-pair.response';

@jsonObject
export class SequenceSearchResultHitDataResponse {
  @jsonMember readonly accession!: string;
  @jsonMember readonly length!: number;
  @jsonMember readonly num!: number;
  @jsonMember readonly scientificName!: string;
  @jsonMember readonly title!: string;
  @jsonArrayMember(SequenceSearchResultHitSegmentPairResponse)
  readonly highScoringSegmentPairs!: SequenceSearchResultHitSegmentPairResponse[];
}
